import posthog from "posthog-js"

const posthogToken = process.env.NEXT_PUBLIC_POSTHOG_PROJECT_TOKEN
const posthogHost = process.env.NEXT_PUBLIC_POSTHOG_HOST
const isPostHogEnabled = process.env.NODE_ENV === "production" && posthogToken && posthogHost

// A cross-origin script that throws is stripped by the browser to a bare
// "Script error." with no stack. Such events carry nothing to act on, so drop
// them before they open empty high-severity error tracking issues.
const isStacklessScriptError = (event) => {
  if (event?.event !== "$exception") return false
  const exceptions = event.properties?.$exception_list ?? []
  if (exceptions.length === 0) return false
  return exceptions.every((exception) => {
    const message = (exception?.value ?? "").trim()
    const frames = exception?.stacktrace?.frames ?? []
    return frames.length === 0 && /^script error\.?$/i.test(message)
  })
}

// The OneSignal web SDK mounts on every route via the root-layout provider and
// loads from its own CDN. On mobile Safari the SDK opens an IndexedDB
// connection that the browser can close during page freeze or discard, and an
// in-flight read then throws inside the third-party bundle. Portal code cannot
// catch it. Every frame resolves to the OneSignal CDN, not this repo, so drop
// the event when it has frames and all of them come from that CDN.
const isOnesignalCdnError = (event) => {
  if (event?.event !== "$exception") return false
  const exceptions = event.properties?.$exception_list ?? []
  const frames = exceptions.flatMap((exception) => exception?.stacktrace?.frames ?? [])
  if (frames.length === 0) return false
  return frames.every((frame) =>
    /\/\/cdn\.onesignal\.com\//.test(frame?.filename ?? frame?.abs_path ?? "")
  )
}

if (isPostHogEnabled) {
  posthog.init(posthogToken, {
    api_host: posthogHost,
    defaults: "2026-01-30",
    capture_exceptions: true,
    debug: false,
    before_send: (event) =>
      isStacklessScriptError(event) || isOnesignalCdnError(event) ? null : event,
  })
}
